/*
*
*apis.js 用于定义前后端各种接口
*by zxy
*
*/
//获取axios封装方法
import request from './http.js'
import global from "../global";
/*
*Login——登录页接口
 */
//定义登录
export function LOGIN (parameter) {
  return request({
    baseURL:global.baseURL,
    url: '/login',
    method: 'post',
    data: parameter
  })
}


/*Home-首页*/
//获取登录日志
//获取用户信息
export function GETUSERINFO (parameter) {
  return request({
    baseURL:global.baseURL,
    url: '/adminLogin/getLoginUserInfo',
    method: 'get',
    params: parameter
  })
}

export function LOGOUT (parameter) {
  return request({
    baseURL:global.baseURL,
    url: '/adminLogin/logout',
    method: 'post',
    data: parameter
  })
}

export function GETTABLEDATA (parameter) {
  return request({
    url: '/API/table.json',
    method: 'get',
    params: parameter
  })
}

//解析浏览器url参数
//@variable：参数名称
export function getQueryVariable(variable)
{
	const hash = window.location.hash
	if(hash.indexOf('?') != -1){
		var query = hash.split('?')[1];
	    var vars = query.split("&");
	    for (var i=0;i<vars.length;i++) {
	           var pair = vars[i].split("=");
	           if(pair[0] == variable){return pair[1];}
	    }
	    return(false);
	}else{
		return false;
	}
}


// WEBPACK FOOTER //
// ./static/js/API/apis.js